/**
 * Created by rak on 1/15/2016.
 */
'use strict';

angular.module('trackReporting')
  .controller('RepoGroupDetailCtrl', function ($scope, widgetSettingsCreatorService, commonTrackService, $timeout, reportService, $stateParams, $filter, $translate, errorHandlingService) {
    //var device = {};
    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
    var startDate = '';
    var endDate = '';
    var mainUrlDetails = '&page=map.device.full';
    var column = [];
    var reportOptions = ['tripReport', 'motionSummary', 'eventSpeedOption', 'eventSpeedPosted', 'digitalInputDetailReport'];
    var _selectedReportOption = '';
    var _selectedReportOptionModel = '';
    $scope.moduleName = 'groupdetailsreport';
    $scope.isDataAvailable = true;
    var isGridCreated = false;
    var radioCache = commonTrackService.getDataFromLocalStorage('groupDetailRadioName');
    $scope.radio = {
      name: $stateParams.reportName ? $stateParams.reportName : (radioCache ? radioCache : 'EventDetail_Group')
    };
    var lastlocationWidgetData = commonTrackService.getsetLastLocatioWidgetData();

    $scope.reportComboOption = {
      tripReport: null,
      motionSummary: null,
      eventSpeedOption: null,
      eventSpeedPosted: null,
      digitalInputDetailReport: null
    };

    $scope.groupDetailReportPropList = [{
      _isEnabled: true,
      _reportName: 'EventDetail_Group',
      _idName: 'eventDetail_GroupRadio',
      _translationProp: 'trackReporting.groupDetailReport.eventDetail_Group',
      _hasOption: false,
      _hasMap: false
    }, {
      _isEnabled: false,
      _reportName: 'EventDetailOBDLight_Group',
      _idName: 'eventDetailOBDLight_GroupRadio',
      _translationProp: 'trackReporting.groupDetailReport.eventDetailOBDLight_Group',
      _hasOption: false,
      _hasMap: false
    },
      {
        _isEnabled: true,
        _reportName: 'TripReport_Group',
        _idName: 'tripReport_GroupRadio',
        _translationProp: 'trackReporting.groupDetailReport.tripReport_Group',
        _hasOption: true,
        _comboID: 'tripreportComboBox',
        _comboModelName: 'tripReport',
        _comboSettings: 'tripReportSettings',
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'MotionSummary_Group',
        _idName: 'motionSummary_GroupRadio',
        _translationProp: 'trackReporting.groupDetailReport.motionSummary_Group',
        _hasOption: true,
        _comboID: 'motionsummaryComboBox',
        _comboModelName: 'motionSummary',
        _comboSettings: 'motionSummarySettings',
        _hasMap: false
      }, {
        _isEnabled: true,
        _reportName: 'GeozoneReport_Group',
        _idName: 'geozoneReport_GroupRadio',
        _translationProp: 'trackReporting.groupDetailReport.geozoneReport_Group',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'GeozoneDriving_Group',
        _idName: 'geozoneDriving_GroupRadio',
        _translationProp: 'trackReporting.groupDetailReport.geozoneDriving_Group',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'EventSpeedOption_Group',
        _idName: 'eventSpeedOption_GroupRadio',
        _translationProp: 'trackReporting.groupDetailReport.eventSpeedOption_Group',
        _hasOption: true,
        _comboID: 'speedOverComboBox',
        _comboModelName: 'eventSpeedOption',
        _comboSettings: 'eventSpeedOptionSettings',
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'EventExcessSpeed_Group',
        _idName: 'eventExcessSpeed_GroupRadio',
        _translationProp: 'trackReporting.groupDetailReport.eventExcessSpeed_Group',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'EventSpeedPosted_Group',
        _idName: 'eventSpeedPosted_GroupRadio',
        _translationProp: 'trackReporting.groupDetailReport.eventSpeedPosted_Group',
        _hasOption: true,
        _comboID: 'eventSpeedPostedComboBox',
        _comboModelName: 'eventSpeedPosted',
        _comboSettings: 'eventSpeedPostedSettings',
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'EventIdle_Group',
        _idName: 'eventIdle_GroupRadio',
        _translationProp: 'trackReporting.groupDetailReport.eventIdle_Group',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: false,
        _reportName: 'EventExcessiveIdle_Group',
        _idName: 'eventExcessiveIdle_GroupRadio',
        _translationProp: 'trackReporting.groupDetailReport.eventExcessiveIdle_Group',
        _hasOption: false,
        _hasMap: false
      }, {
        _isEnabled: true,
        _reportName: 'DigitalInputDetailReport_Group',
        _idName: 'digitalInputDetailReport_GroupRadio',
        _translationProp: 'trackReporting.groupDetailReport.digitalInputDetailReport_Group',
        _hasOption: true,
        _comboID: 'digitalinputdetailreportComboBox',
        _comboModelName: 'digitalInputDetailReport',
        _comboSettings: 'digitalInputDetailReportSettings',
        _hasMap: false
      }, {
        _isEnabled: true,
        _reportName: 'NotifyQueueDetail_Group',
        _idName: 'notifyQueueDetail_GroupRadio',
        _translationProp: 'trackReporting.groupDetailReport.notifyQueueDetail_Group',
        _hasOption: false,
        _hasMap: false
      }
    ];

    $scope.reportHistory = '';

    $scope.diableRepoTab = {
      report: true
    };

    $scope.showRepoTab = 0;

    var source =
      {
        datatype: 'array',
        datafields: [],
        localdata: []
      };
    $scope.date = {
      startDate: $stateParams.dateFrom ? new Date($stateParams.dateFrom.replaceAll('-', '/').replace('T', ' ')) : new Date(commonTrackService.formatReportDateTime($filter('date')(new Date(), 'dd/MM/yyyy'), '00:00:00')),
      endDate: $stateParams.dateFrom ? new Date($stateParams.dateTo.replaceAll('-', '/').replace('T', ' ')) : new Date()
    };
    var dateRangeCustomEventHandler = {
      eventHandlers: {
        'apply.daterangepicker': function () {
          startDate = $scope.date.startDate._isAMomentObject ? $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
          endDate = $scope.date.startDate._isAMomentObject ? $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');
          if ($scope.showRepoTab === 1) {
            $scope.getReport($scope.reportHistory, $scope.hasMap, _selectedReportOptionModel);
          }
          /* $timeout(function () {
           $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails + '&group=' + device.value + '&date_fr=' + startDate + '&date_to=' + endDate);
           }, 0);*/
        }
      }
    };
    $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler);
    var loadFleetServerDetails = function () {
      return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
        $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
        $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails);
      });
    };

    $scope.repoGroupSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'groupID'
    });

    $scope.tripReportSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    $scope.motionSummarySettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    $scope.eventSpeedOptionSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    $scope.eventSpeedPostedSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    $scope.digitalInputDetailReportSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    var loaddevice = function () {
      return commonTrackService.getVehicleGroupComboList().then(function (groupList) {
        var cacheData = commonTrackService.getDataFromLocalStorage('groupDetailReport');
        $scope.repoGroupSettings.source = groupList;
        if ($stateParams.groupId) {
          $scope.repoGroup = $stateParams.groupId;
        } else if (lastlocationWidgetData.selectedVehicleGroup && lastlocationWidgetData.selectedVehicleGroup !== 'all') {
          $scope.repoGroup = lastlocationWidgetData.selectedVehicleGroup;
        } else if (cacheData) {
          $scope.repoGroup = cacheData;
        } else {
          $scope.repoGroup = $scope.repoGroupSettings.source[0].groupID;
        }
      });
    };
    var loadReportOptions = function (name) {
      reportService.getCustomGroupRepotOptionComboData(name).then(function (reportOptionData) {
        for (var i = 0; i < reportOptionData.length; i++) {
          reportOptionData[i].displayName = $translate.instant('trackReporting.groupDetailReport.reportComboboxOptions.' + name + '.' + reportOptionData[i].key);
        }
        $scope[name + 'Settings'].source = reportOptionData;
        $scope.reportComboOption[name] = reportOptionData[0].key;
      });
    };

    loadFleetServerDetails().then(function () {
      return loaddevice();
    }).finally(function () {
      $('#grpDetailRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());

      for (var i = 0; i < reportOptions.length; i++) {
        loadReportOptions(reportOptions[i]);
      }
      initExport();


      $scope.dataLoadingFinished = true;

      if ($stateParams.reportName && $stateParams.groupId && $stateParams.dateFrom && $stateParams.dateTo) {
        $timeout(function () {
          $scope.getReport($stateParams.reportName, false);
          $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').on('bindingcomplete', function () {
            isGridCreated = true;
            $timeout(function () {
              $('#grpDetailRepoSpliter').jqxSplitter('render');
            }, 400);

          });
        }, 100);
      }

      $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').on('bindingcomplete', function () {
        isGridCreated = true;
        $timeout(function () {
          $('#grpDetailRepoSpliter').jqxSplitter('render');
        }, 100);
      });

      $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').on('rowselect', function (event) {
        if (event.args && event.args.row && event.args.row.timestamp) {
          commonTrackService.iframePostMessage('jsmShowDetailPushpinForRoute_Dsa(' + event.args.row.timestamp + ')', 'groupMap');
        }
      });
    });

    $scope.getReport = function (reportName, hasMap, reportOption, event) {
      $scope.mapUrl = '';
      var gridState = reportService.getReportGridState('groupDetailReport', reportName);
      _selectedReportOptionModel = reportOption;
      $scope.error = false;
      $scope.exportOption = 'HTML';
      $scope.diableRepoTab.report = false;
      $scope.hasMap = hasMap;
      $scope.dataLoadingFinished = false;

      startDate = startDate && !startDate._isAMomentObject ? startDate : $filter('date')($scope.date.startDate._isAMomentObject ? $scope.date.startDate._d : $scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
      endDate = endDate && !endDate._isAMomentObject ? endDate : $filter('date')($scope.date.endDate._isAMomentObject ? $scope.date.endDate._d : $scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');


      _selectedReportOption = $scope.reportComboOption[reportOption] && reportOption ? $scope.reportComboOption[reportOption] : '';
      if ($scope.hasMap) {
        $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, reportName, 'group', event ? event.args.item.value : $scope.repoGroup, _selectedReportOption ? _selectedReportOption : '', startDate, endDate);
      }
      var _tmpReportData = null;
      reportService.getGroupReport($scope.moduleName, event ? event.args.item.value : $scope.repoGroup, endDate, startDate, $scope.reportHistory !== reportName ? true : false, reportName, _selectedReportOption !== null ? _selectedReportOption : '').then(function (detailReport) {
        $scope.isDataAvailable = true;
        _tmpReportData = detailReport;
        if ($scope.reportHistory !== reportName) {
          $scope.reportHistory = reportName;
          source.localdata = detailReport.dataList;
          column = commonTrackService.getColumnProperties(detailReport.gridSettings.overviewListGrids[0].columnProperties, detailReport.columnTranslation, {
            moduleName: reportName,
            reportModel: 'groupDetailReport'
          });
          var isGroupable = false;
          if (column[0].datafield === 'deviceid') {
            isGroupable = true;
          }
          var _additionalProperties = {
            translatedName: $translate.instant('trackReporting.groupDetailReport.' + reportName.toLoawerCaseAt(0)),
            isDynamicGrid: true,
            dynamicModuleName: reportName
          };
          $scope.gridSettings = commonTrackService.getGridSettings('groupDetailReport', {
            pagesizeoptions: ['25', '50', '100'],
            pagesize: 25,
            columns: column,
            autosavestate: false,
            height: 675,
            autoloadstate: false,
            groupable: isGroupable,
            groups: [column[0].datafield]
          }, null, _additionalProperties);
          $scope.dataAdapter = new $.jqx.dataAdapter(source);
          $scope.gridSettings.source = $scope.dataAdapter;
          // should be executed only after once successfully creating grid or else 'grid container will be lost', following needed for Jqx 4 changes.
          if (isGridCreated) {
            $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').jqxGrid({
              source: $scope.dataAdapter,
              columns: column
            });
          }
          $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').jqxGrid($scope.gridSettings);
        }
        else {
          source.localdata = detailReport.dataList;
          $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').jqxGrid('updatebounddata', 'data');
        }
      }, function (response) {
        $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').jqxGrid('clear');
        $scope.reportHistory = '';
        $scope.mapUrl = '';
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isDataAvailable = false;
        }
      }).finally(function () {

        $timeout(function () {
          $scope.showRepoTab = 1;
          if (!$scope.hasMap) {
            $('#grpDetailRepoSpliter').jqxSplitter(reportService.getReportSplitterWithoutMapPannel());
          } else {
            $('#grpDetailRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());
          }
          if (!$scope.isEventRegistered) {
            $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').on('filter', function () {
              saveGridSate();
            });
            $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').on('columnresized', function () {
              saveGridSate(reportName);
            });

            $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').on('columnreordered', function () {
              saveGridSate(reportName);
            });

            $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').on('sort', function () {
              saveGridSate(reportName);
            });
            $scope.isEventRegistered = true;
          }
        }, 0);
        //  $('#vehicleDetailReportList').jqxGrid('render');
        $timeout(function () {
          var gridLocalStorageUserSettingKey = reportName + '-' + $scope.overviewGridPrefix + 'groupDetailReportList';
          reportService.loadReportCustomGridState(_tmpReportData, '#' + $scope.overviewGridPrefix + 'groupDetailReportList', $scope.gridSettings, gridState, gridLocalStorageUserSettingKey);
        }, 1000);
        column = null;
      });
    };

    function saveGridSate() {
      var reportSate = $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').jqxGrid('getstate');
      reportService.setReportGridState('groupDetailReport', $scope.radio.name, reportSate);
    }

    function initExport() {
      $scope.exportSetting = reportService.getExportSettings();
      $scope.exportSetting.selectedIndex = 0;
      $scope.exportOption = 'HTML';
    }

    $scope.exportChange = function (event) {
      $scope.exportURL='';
      if (event.args && event.args.item.value !== 'EMail' && event.args.item.value !== 'HTML') {

        $scope.exportURL = commonTrackService.getExportURL($scope.reportHistory, event.args.item.value, 'group', $scope.repoGroup, _selectedReportOption ? _selectedReportOption : '', startDate, endDate);
        reportService.doExport($scope.exportURL, $scope.reportHistory, event.args.item.value);
      } else {
        $scope.exportURL = commonTrackService.getExportURL($scope.reportHistory, event, 'group', $scope.repoGroup, _selectedReportOption ? _selectedReportOption : '', startDate, endDate, $scope.emailAddresses);
        if (!event.args) {
          reportService.doExport($scope.exportURL, $scope.reportHistory, 'EMail');
        }
      }
    };

    $scope.repoGroupComboChange = function (event) {
      var selectItem = event.args.item;
      if (selectItem) {
        commonTrackService.setDataToLocalStorage('groupDetailReport', selectItem.value);
      }
      if ($scope.showRepoTab === 1) {
        $scope.getReport($scope.reportHistory, $scope.hasMap, _selectedReportOptionModel, event);
      }
    };
    $scope.$watch('radio.name', function (value) {
      if (value) {
        // after new layout 4 $parent is required to keep breadcrump to keep the link ( better solution have to be found)
        $scope.$parent.breadCrumbLabel = $translate.instant('trackReporting.groupDetail') + ' / ' + $translate.instant('trackReporting.groupDetailReport.' + $scope.radio.name._toLowerCaseAtIndex(0));
        $scope.$parent.$parent.$parent.$parent.breadCrumbLabel = $translate.instant('trackReporting.groupDetail') + ' / ' + $translate.instant('trackReporting.groupDetailReport.' + $scope.radio.name._toLowerCaseAtIndex(0));
        commonTrackService.setDataToLocalStorage('groupDetailRadioName', value);
      }
    });

    $scope.cancel = function () {
      $scope.showRepoTab = 0;
    };
    var updateDateRangeInternalDateEvent = $scope.$on('date-range-internalDate-old', function () {
      $scope.options.ranges = commonTrackService.setDateRangePickerCustomOptions($scope.options);
    });

    $scope.$on('$destroy', function () {
      updateDateRangeInternalDateEvent();
      if ($scope.dataAdapter) {
        delete  $scope.dataAdapter;
      }
      if ($scope.gridSettings && $scope.gridSettings.source) {
        delete $scope.gridSettings.source;
      }
    });
  });



// WEBPACK FOOTER //
// ./.tmp/components/track/reports/groupDetailReportController.js